// material
import { Button, Card, CardActions, CardContent, Container, Grid, Typography } from '@mui/material';
import { useState } from 'react';

// components
import Page from '../components/Page';
import IccidOrganizationDialog from '../components/Dialogs/IccidOrganizationDialog';

const ACTIONS = [
  {
    action: 'assign',
    title: 'Assign',
    description: 'Give unheld ICCIDs to an organization.',
    button: 'Assign to organization',
  },
  {
    action: 'unassign',
    title: 'Unassign',
    description: 'Take ICCIDs back from whichever organization holds them.',
    button: 'Unassign organization',
  },
  {
    action: 'transfer',
    title: 'Transfer',
    description: 'Move ICCIDs from one organization to another.',
    button: 'Transfer organization',
  },
];

export default function IccidOrganization() {
  const [action, setAction] = useState('assign');
  const [open, setOpen] = useState(false);

  const handleOpen = (nextAction) => {
    setAction(nextAction);
    setOpen(true);
  };

  return (
    <Page title="Iccid organization">
      <IccidOrganizationDialog open={open} action={action} handleClose={() => setOpen(false)} />
      <Container>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Iccid organization
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Assign, unassign or transfer ICCIDs by range, list or file — up to 1000 per request.
        </Typography>
        <Grid container spacing={3}>
          {ACTIONS.map(({ action, title, description, button }) => (
            <Grid item xs={12} md={4} key={action}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    {title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2 }}>
                  <Button fullWidth variant="contained" onClick={() => handleOpen(action)}>
                    {button}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Page>
  );
}
